import { render } from "./DataNode.vue?vue&type=template&id=c95a7926&scoped=true&ts=true"
import script from "./DataNode.vue?vue&type=script&lang=ts"
export * from "./DataNode.vue?vue&type=script&lang=ts"

import "./DataNode.vue?vue&type=style&index=0&id=c95a7926&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c95a7926"]])

export default __exports__